module.exports = __webpack_public_path__ + "static/netbeans_project-1ca806e4110f625f1066916f36fe4d31.png";